/**
 * Email provider whitelist utility.
 * Enforces that Free Tier users use a common personal email provider.
 * This effectively blocks both disposable emails and corporate/org accounts.
 */
const ALLOWED_PERSONAL_DOMAINS = new Set([
  'gmail.com', 'outlook.com', 'hotmail.com', 'yahoo.com', 'icloud.com', 
  'proton.me', 'protonmail.com', 'live.com', 'me.com', 'aol.com', 'yandex.com',
  'mail.com', 'gmx.com', 'zoho.com', 'googlemail.com', 'msn.com', 'dopove.com'
]);

/**
 * Returns true if the email belongs to a trusted personal provider.
 * @param {string} email
 * @returns {boolean}
 */
export function isAllowedPersonalEmail(email) {
  if (!email || !email.includes('@')) return false;
  const parts = email.trim().toLowerCase().split('@');
  const domain = parts[parts.length - 1]; // Get everything after the last @
  return ALLOWED_PERSONAL_DOMAINS.has(domain);
}

/**
 * Returns a user-facing error message if invalid, or null if valid.
 * @param {string} email
 * @returns {string|null}
 */
export function validateEmail(email) {
  if (!email) return 'Email is required.';
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return 'Please enter a valid email address.';
  
  if (!isAllowedPersonalEmail(email)) {
    return 'Invalid email';
  }
  
  return null;
}
